module.exports = __webpack_public_path__ + "static/media/green4.ac8d4d63.jpg";